import { render, staticRenderFns } from "./tab_io_detail_ys_d.vue?vue&type=template&id=6563da7c&scoped=true"
import script from "./tab_io_detail_ys_d.vue?vue&type=script&lang=js"
export * from "./tab_io_detail_ys_d.vue?vue&type=script&lang=js"
import style0 from "./tab_io_detail_ys_d.vue?vue&type=style&index=0&id=6563da7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6563da7c",
  null
  
)

export default component.exports